module.exports = __webpack_public_path__ + "img/lufthansa.e8b0a6c1.svg";